import { formatISO } from 'date-fns';
import { BasicValueUnitGetModuleFactory } from '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import { InstrumentGetByNotationModuleFactory } from '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import { InstrumentExchangeRateGetByIsoCodeModuleFactory } from '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import { PricesListModuleFactory } from '../../endpoints/prices/list.module.js';
import { DebtInstrumentGetModuleFactory } from '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import { SecuritizedDerivativeGetModuleFactory } from '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import { PortfolioPositionListModuleFactory } from '../../endpoints/portfolio/position/list.module.js';
import { PortfolioGetModuleFactory } from '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import { PortfolioTransactionCreateModuleFactory } from '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import { InstrumentNotationListModuleFactory } from '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { FactsheetHeaderStoreModuleFactory } from '../factsheet-header/index.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { getLanguage, mapAssetClass, convertMdg2DateTimeResponse, getPercentage, inheritEndpointOptions, getEndpointOptions } from '../../helpers/common.js';
import { getInstrumentNotationListRequestMarketFilter, getInstrumentNotationListRequestSort } from '../../helpers/endpoints.js';

var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
class PortfolioTransactionError extends Error {
  constructor(message) {
    super(message);
  }
}
class PortfolioTransactionAddStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultNameType = "name";
    this.defaultLanguage = "en";
    this.defaultFallbackForNameType = true;
    this.factsetForextRateMarketId = 406;
    this.defaultTransactionLimit = 1e3;
    this.defaultNumberOfShares = 0;
    this.transactionTypeValidationPattern = /^(buy|sell|short|cover)$/;
    this.buyDateValidationPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;
    this.buyPriceValidationPattern = /^\d+(\.\d+)?$/;
    this.exchangeRateValidationPattern = /^\d+(\.\d+)?$/;
    this.quantityValidationPattern = /^\d+$/;
    this.nameType = (_d = (_c = (_b = (_a = this.options) == null ? void 0 : _a.instrument) == null ? void 0 : _b.name) == null ? void 0 : _c.type) != null ? _d : this.defaultNameType;
    this.isNameTypeFallbackEnabled = (_h = (_g = (_f = (_e = this.options) == null ? void 0 : _e.instrument) == null ? void 0 : _f.name) == null ? void 0 : _g.fallback) != null ? _h : this.defaultFallbackForNameType;
    this.quality = (_k = (_j = (_i = this.options) == null ? void 0 : _i.prices) == null ? void 0 : _j.quality) != null ? _k : "BST";
    this.sameQuality = (_n = (_m = (_l = this.options) == null ? void 0 : _l.prices) == null ? void 0 : _m.sameQuality) != null ? _n : false;
    this.numberOfTransactionsPerUser = (_p = (_o = this.options) == null ? void 0 : _o.numberOfTransactionsPerUser) != null ? _p : this.defaultTransactionLimit;
    this.exchangeRateMarkets = (_t = (_s = (_r = (_q = this.options) == null ? void 0 : _q.exchangeRate) == null ? void 0 : _r.market) == null ? void 0 : _s.ids) != null ? _t : [this.factsetForextRateMarketId];
    this.defaultInstrumentNotationListSort = ["-notations.tradingVolume.month1.average"];
    this.percentCurrencyCode = "%";
  }
  getPortfolioGetRequest(id) {
    return { id };
  }
  getPortfolioGetData(payload) {
    var _a2;
    const request = this.getPortfolioGetRequest(payload.id);
    const response = this.getEndpoints().portfolioGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getInstrumentGetByNotationRequest(id, payloadLanguage) {
    return { id, _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getInstrumentGetByNotationData(payload) {
    var _a2;
    const request = this.getInstrumentGetByNotationRequest(payload.securityId, payload.language);
    const response = this.getEndpoints().instrumentGetByNotation.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getPricesListNotationDataRequest(id) {
    return { id, quality: this.quality, sameQuality: this.sameQuality };
  }
  getPricesListNotationData(payload) {
    var _a2;
    const request = this.getPricesListNotationDataRequest(payload.securityId);
    const response = this.getEndpoints().pricesList.getNotationData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getValueUnitId(payload) {
    const pricesListNotationData = this.getPricesListNotationData(payload);
    if (!(pricesListNotationData == null ? void 0 : pricesListNotationData.valueUnit.id)) {
      throw new Error("Could not get value unit id");
    }
    return pricesListNotationData.valueUnit.id;
  }
  getBasicValueUnitGetRequest(id) {
    return { id };
  }
  getBasicValueUnitGetData(payload, id) {
    var _a2;
    try {
      const valueUnitId = id != null ? id : this.getValueUnitId(payload);
      const request = this.getBasicValueUnitGetRequest(valueUnitId);
      const response = this.getEndpoints().basicValueUnitGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getPortfolioPositionListRequest(id) {
    return { id };
  }
  getPortfolioPositionListData(payload) {
    var _a2;
    const request = this.getPortfolioPositionListRequest(payload.id);
    const response = this.getEndpoints().portfolioPositionList.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getPortfolioPosition(payload) {
    var _a2;
    const portfolioPositionListData = this.getPortfolioPositionListData(payload);
    const securityPosition = ((_a2 = portfolioPositionListData == null ? void 0 : portfolioPositionListData.positions) != null ? _a2 : []).find((item) => item.notation.id === payload.securityId);
    return securityPosition != null ? securityPosition : null;
  }
  getDebtInstrumentGetRequest(identifier, payloadLanguage) {
    return { identifier, identifierType: "idNotation", _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options) };
  }
  getDebtInstrumentGetData(payload) {
    var _a2;
    const request = this.getDebtInstrumentGetRequest(payload.securityId, payload.language);
    const response = this.getEndpoints().debtInstrumentGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getPortfolioCurrencyCode(payload) {
    const portfolioGetData = this.getPortfolioGetData(payload);
    if (!(portfolioGetData == null ? void 0 : portfolioGetData.currency.isoCode)) {
      throw new Error("Could not get portfolio currency");
    }
    return portfolioGetData.currency.isoCode;
  }
  getInstrumentExchangeRateGetByIsoCodeRequest(target, source, payloadLanguage) {
    return {
      target,
      source,
      _language: getLanguage(payloadLanguage, this.defaultLanguage, this.options)
    };
  }
  getInstrumentExchangeRateGetByIsoCodeData(payload) {
    var _a2;
    try {
      const portfolioCurrency = this.getPortfolioCurrencyCode(payload);
      const securityCurrency = this.getSecurityCurrency(payload);
      if (!securityCurrency)
        return null;
      const request = this.getInstrumentExchangeRateGetByIsoCodeRequest(securityCurrency, portfolioCurrency, payload.language);
      const response = this.getEndpoints().instrumentExchangeRateGetByIsoCode.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getInstrumentNotationListRequest(id, payloadLanguage) {
    var _a2, _b2, _c2;
    return {
      data: {
        identifier: {
          type: "idInstrument",
          values: [id]
        },
        filter: getInstrumentNotationListRequestMarketFilter(
          (_b2 = (_a2 = this.options) == null ? void 0 : _a2.markets) != null ? _b2 : {
            restrict: this.exchangeRateMarkets
          }
        )
      },
      meta: {
        sort: getInstrumentNotationListRequestSort((_c2 = this.options) == null ? void 0 : _c2.markets, this.defaultInstrumentNotationListSort),
        language: getLanguage(payloadLanguage, this.defaultLanguage, this.options)
      }
    };
  }
  getExchangeRateGetByIsoCodeInstrumentId(payload) {
    const instrumentExchangeRateGetByIsoCodeData = this.getInstrumentExchangeRateGetByIsoCodeData(payload);
    if (!(instrumentExchangeRateGetByIsoCodeData == null ? void 0 : instrumentExchangeRateGetByIsoCodeData.instrument.id)) {
      throw new Error("Could not get exchange rate instrument id");
    }
    return instrumentExchangeRateGetByIsoCodeData.instrument.id;
  }
  getExchangeRateInstrumentNotationListData(payload) {
    var _a2;
    try {
      const exchangeRateInstrumentId = this.getExchangeRateGetByIsoCodeInstrumentId(payload);
      const request = this.getInstrumentNotationListRequest(exchangeRateInstrumentId, payload.language);
      const response = this.getEndpoints().instrumentNotationList.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getExchangeRateNotationId(payload) {
    var _a2;
    const instrumentNotationListData = this.getExchangeRateInstrumentNotationListData(payload);
    const notationId = (_a2 = instrumentNotationListData == null ? void 0 : instrumentNotationListData[0].notations[0]) == null ? void 0 : _a2.id;
    if (!notationId) {
      throw new Error("Could not get notation id");
    }
    return notationId;
  }
  getExchangeRatePricesListRequest(id) {
    return {
      id,
      quality: this.quality,
      sameQuality: this.sameQuality
    };
  }
  getExchangeRatePriceData(payload) {
    var _a2;
    try {
      const exchangeRateNotationId = this.getExchangeRateNotationId(payload);
      const request = this.getExchangeRatePricesListRequest(exchangeRateNotationId);
      const response = this.getEndpoints().pricesList.getNotationData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  securityHasExchangeRate(payload) {
    try {
      const securityCurrency = this.getSecurityCurrency(payload);
      const portfolioCurrency = this.getPortfolioCurrencyCode(payload);
      return portfolioCurrency !== securityCurrency;
    } catch (e) {
      return false;
    }
  }
  getResponseData(payload) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j2, _k2, _l2;
    const portfolioGetData = this.getPortfolioGetData(payload);
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    const pricesListNotationData = this.getPricesListNotationData(payload);
    const valueUnitData = this.getBasicValueUnitGetData(payload);
    const position = this.getPortfolioPosition(payload);
    const assetClass = mapAssetClass(instrumentData == null ? void 0 : instrumentData.assetClass.code);
    const securityCurrency = this.getSecurityCurrency(payload);
    const exchangeRatePriceData = this.securityHasExchangeRate(payload) ? this.getExchangeRatePriceData(payload) : null;
    const currencyIsPercent = this.securityIsPercent(payload);
    const nameFallback = this.isNameTypeFallbackEnabled ? (_a2 = instrumentData == null ? void 0 : instrumentData.name) != null ? _a2 : null : null;
    const lastPrice = (_b2 = pricesListNotationData == null ? void 0 : pricesListNotationData.latest.price) != null ? _b2 : null;
    const exchangeRate = (_c2 = exchangeRatePriceData == null ? void 0 : exchangeRatePriceData.latest.price) != null ? _c2 : 1;
    return {
      portfolio: {
        id: payload.id,
        name: (_d2 = portfolioGetData == null ? void 0 : portfolioGetData.name) != null ? _d2 : null,
        currency: (_e2 = portfolioGetData == null ? void 0 : portfolioGetData.currency.isoCode) != null ? _e2 : null,
        position: {
          id: (_f2 = position == null ? void 0 : position.notation.id) != null ? _f2 : null,
          securityIdentifier: payload.securityId,
          name: (_g2 = instrumentData == null ? void 0 : instrumentData[this.nameType]) != null ? _g2 : nameFallback,
          isin: (_h2 = instrumentData == null ? void 0 : instrumentData.isin) != null ? _h2 : null,
          assetClass,
          currency: (_j2 = (_i2 = valueUnitData == null ? void 0 : valueUnitData.code) != null ? _i2 : valueUnitData == null ? void 0 : valueUnitData.isoCode) != null ? _j2 : null,
          currencyIsPercent,
          numberOfShares: (_k2 = position == null ? void 0 : position.shares.open) != null ? _k2 : this.defaultNumberOfShares,
          lastPrice,
          lastPriceDateTime: convertMdg2DateTimeResponse((_l2 = pricesListNotationData == null ? void 0 : pricesListNotationData.latest.time) != null ? _l2 : null),
          exchangeRate,
          buyValue: {
            inPortfolioCurrency: lastPrice && currencyIsPercent ? getPercentage(lastPrice) : lastPrice,
            currency: securityCurrency
          }
        }
      }
    };
  }
  securityIsPercent(payload) {
    const assetClass = this.getAssetClass(payload);
    if (assetClass === "bond") {
      return true;
    }
    const valueUnitData = this.getBasicValueUnitGetData(payload);
    if (this.isDerivative(assetClass) && (valueUnitData == null ? void 0 : valueUnitData.code) === this.percentCurrencyCode) {
      return true;
    }
    return false;
  }
  getResponseMeta(payload) {
    return {
      validationRules: {
        transactionType: { pattern: this.transactionTypeValidationPattern },
        buyDate: { pattern: this.buyDateValidationPattern },
        buyPrice: { pattern: this.buyPriceValidationPattern },
        exchangeRate: { pattern: this.exchangeRateValidationPattern },
        quantity: { pattern: this.quantityValidationPattern }
      }
    };
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  getNumberOfTransactions(payload) {
    var _a2;
    const portfolioData = this.getPortfolioGetData(payload);
    return (_a2 = portfolioData == null ? void 0 : portfolioData.summary.transactions.total.number) != null ? _a2 : 0;
  }
  async updatePortfolioGet(payload) {
    const request = this.getPortfolioGetRequest(payload.id);
    return this.getEndpoints().portfolioGet.updateState(request);
  }
  getPortfolioTransactionCreateRequest(payload) {
    return {
      data: {
        id: payload.id,
        type: payload.transactionType,
        notation: {
          id: payload.securityId
        },
        time: formatISO(payload.buyDate),
        numberShares: payload.quantity,
        price: payload.buyPrice,
        exchangeRate: payload.exchangeRate
      }
    };
  }
  async updatePortfolioTransactionCreate(payload) {
    try {
      const numberOfTransactions = this.getNumberOfTransactions(payload);
      if (numberOfTransactions >= this.numberOfTransactionsPerUser) {
        throw new PortfolioTransactionError("transactionLimitExceededMessage");
      }
      const request = this.getPortfolioTransactionCreateRequest(payload);
      return this.getEndpoints().portfolioTransactionCreate.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updatePortfolioPositionList(payload) {
    const request = this.getPortfolioPositionListRequest(payload.id);
    return this.getEndpoints().portfolioPositionList.updateState(request);
  }
  async updateInstrumentGetByNotation(payload) {
    const request = this.getInstrumentGetByNotationRequest(payload.securityId, payload.language);
    return this.getEndpoints().instrumentGetByNotation.updateState(request);
  }
  getPricesListRequest(id) {
    return { identifiers: [id], identifierType: "idNotation", quality: this.quality, sameQuality: this.sameQuality };
  }
  async updatePricesList(payload) {
    const request = this.getPricesListRequest(payload.securityId);
    return this.getEndpoints().pricesList.updateState(request);
  }
  async updateDebtInstrumentGet(payload) {
    const request = this.getDebtInstrumentGetRequest(payload.securityId, payload.language);
    return this.getEndpoints().debtInstrumentGet.updateState(request);
  }
  async updateBasicValueUnitGet(payload, id) {
    try {
      let valueUnitId = id;
      if (!valueUnitId) {
        await this.updatePricesList(payload);
        valueUnitId = this.getValueUnitId(payload);
      }
      const request = this.getBasicValueUnitGetRequest(valueUnitId);
      return this.getEndpoints().basicValueUnitGet.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateExchangeRatePricesList(payload) {
    try {
      await this.updateInstrumentNotationList(payload);
      const exchangeRateNotationId = this.getExchangeRateNotationId(payload);
      const request = this.getPricesListRequest(exchangeRateNotationId);
      return this.getEndpoints().pricesList.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateInstrumentNotationList(payload) {
    try {
      await this.updateInstrumentExchangeRateGetByIsoCode(payload);
      const exchangeRateGetByIsoCodeInstrumentId = this.getExchangeRateGetByIsoCodeInstrumentId(payload);
      const request = this.getInstrumentNotationListRequest(exchangeRateGetByIsoCodeInstrumentId, payload.language);
      return this.getEndpoints().instrumentNotationList.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateInstrumentExchangeRateGetByIsoCode(payload) {
    try {
      const portfolioCurrency = this.getPortfolioCurrencyCode(payload);
      const securityCurrency = this.getSecurityCurrency(payload);
      if (!securityCurrency) {
        throw new Error("Could not get security currency");
      }
      if (portfolioCurrency === securityCurrency) {
        throw new Error("Target currency and source currency must be different");
      }
      const request = this.getInstrumentExchangeRateGetByIsoCodeRequest(securityCurrency, portfolioCurrency, payload.language);
      return this.getEndpoints().instrumentExchangeRateGetByIsoCode.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  getAssetClass(payload) {
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    return mapAssetClass(instrumentData == null ? void 0 : instrumentData.assetClass.code);
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      switch (payload.action) {
        case "ADD": {
          await this.updatePortfolioGet(payload);
          await this.updatePortfolioTransactionCreate(payload);
          break;
        }
        case "FETCH":
        default: {
          await Promise.all([
            this.updatePortfolioPositionList(payload),
            this.updatePortfolioGet(payload),
            this.updatePricesList(payload),
            this.updateInstrumentGetByNotation(payload)
          ]);
          const assetClass = this.getAssetClass(payload);
          if (assetClass === "bond") {
            await this.updateDebtInstrumentGet(payload);
          } else if (assetClass === "investmentProduct") {
            await this.updateSecuritizedDerivativeGet(payload);
          }
          await this.updateSecurityCurrency(payload);
          if (this.securityHasExchangeRate(payload)) {
            await this.updateExchangeRatePricesList(payload);
          }
          break;
        }
      }
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
      if (error instanceof PortfolioTransactionError) {
        throw error;
      }
    }
    return isResponseSuccessful;
  }
  async updateSecurityCurrency(payload) {
    await this.updateInstrumentGetByNotation(payload);
    const assetClass = this.getAssetClass(payload);
    if (assetClass === "bond") {
      return this.updateBondIssueCurrency(payload);
    }
    if (this.isDerivative(assetClass)) {
      return this.updateDerivativeCurrency(payload);
    }
    return this.updateGenericCurrency(payload);
  }
  async updateBondIssueCurrency(payload) {
    return this.updateDebtInstrumentGet(payload);
  }
  async updateDerivativeCurrency(payload) {
    await this.updateBasicValueUnitGet(payload);
    const valueUnitData = this.getBasicValueUnitGetData(payload);
    if ((valueUnitData == null ? void 0 : valueUnitData.code) === this.percentCurrencyCode) {
      return this.updateDerivativeNominalCurrency(payload);
    }
    return true;
  }
  async updateDerivativeNominalCurrency(payload) {
    await this.updateSecuritizedDerivativeGet(payload);
    const securitizedDerivativeData = this.getSecuritizedDerivativeData(payload);
    if (!(securitizedDerivativeData == null ? void 0 : securitizedDerivativeData.nominal.currency.id)) {
      return false;
    }
    return this.updateBasicValueUnitGet(payload, securitizedDerivativeData.nominal.currency.id);
  }
  async updateGenericCurrency(payload) {
    return this.updateBasicValueUnitGet(payload);
  }
  getSecurityCurrency(payload) {
    var _a2, _b2, _c2, _d2;
    const assetClass = this.getAssetClass(payload);
    if (assetClass === "bond") {
      const debtInstrumentData = this.getDebtInstrumentGetData(payload);
      return (_a2 = debtInstrumentData == null ? void 0 : debtInstrumentData.issue.price.valueUnit.code) != null ? _a2 : null;
    }
    const valueUnitData = this.getBasicValueUnitGetData(payload);
    if (this.isDerivative(assetClass) && (valueUnitData == null ? void 0 : valueUnitData.code) === this.percentCurrencyCode) {
      const securitizedDerivativeData = this.getSecuritizedDerivativeData(payload);
      const nominalValueUnitData = (securitizedDerivativeData == null ? void 0 : securitizedDerivativeData.nominal.currency.id) ? this.getBasicValueUnitGetData(payload, securitizedDerivativeData.nominal.currency.id) : null;
      return (_b2 = nominalValueUnitData == null ? void 0 : nominalValueUnitData.code) != null ? _b2 : null;
    }
    return (_d2 = (_c2 = valueUnitData == null ? void 0 : valueUnitData.code) != null ? _c2 : valueUnitData == null ? void 0 : valueUnitData.isoCode) != null ? _d2 : null;
  }
  isDerivative(assetClass) {
    return ["investmentProduct", "interestRate", "leveragedProduct", "option"].includes(assetClass);
  }
  async cleanUp(payload) {
    return Promise.resolve(true);
  }
  getDependencies() {
    var _a2, _b2;
    if (!this.dependencies) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const genericAdditionalData = ["isin", "wkn", "country"];
      const factsheetHeader = new FactsheetHeaderStoreModuleFactory({
        mdg2Client: this.mdg2Client,
        logger: this.logger,
        store: this.store,
        options: {
          assetClass: {
            generic: {
              additionalData: genericAdditionalData
            }
          },
          ...inheritEndpointOptions(endpointConfiguration, (_b2 = this.options) == null ? void 0 : _b2.factsheetHeader)
        }
      });
      this.dependencies = {
        factsheetHeader
      };
    }
    return this.dependencies;
  }
  getEndpoints() {
    var _a2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.endpoints = {
        portfolioGet: this.getModuleEntity(PortfolioGetModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioGet")),
        portfolioTransactionCreate: this.getModuleEntity(PortfolioTransactionCreateModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioTransactionCreate")),
        portfolioPositionList: this.getModuleEntity(PortfolioPositionListModuleFactory, getEndpointOptions(endpointConfiguration, "portfolioPositionList")),
        instrumentGetByNotation: this.getModuleEntity(InstrumentGetByNotationModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentGetByNotation")),
        pricesList: this.getModuleEntity(PricesListModuleFactory, getEndpointOptions(endpointConfiguration, "pricesList")),
        basicValueUnitGet: this.getModuleEntity(BasicValueUnitGetModuleFactory, getEndpointOptions(endpointConfiguration, "basicValueUnitGet")),
        instrumentExchangeRateGetByIsoCode: this.getModuleEntity(
          InstrumentExchangeRateGetByIsoCodeModuleFactory,
          getEndpointOptions(endpointConfiguration, "instrumentExchangeRateGetByIsoCode")
        ),
        instrumentNotationList: this.getModuleEntity(InstrumentNotationListModuleFactory, getEndpointOptions(endpointConfiguration, "instrumentNotationList")),
        debtInstrumentGet: this.getModuleEntity(DebtInstrumentGetModuleFactory, getEndpointOptions(endpointConfiguration, "debtInstrumentGet")),
        securitizedDerivativeGet: this.getModuleEntity(SecuritizedDerivativeGetModuleFactory, getEndpointOptions(endpointConfiguration, "securitizedDerivativeGet"))
      };
    }
    return this.endpoints;
  }
  getSecuritizedDerivativeGetRequest(id, payloadLanguage) {
    const language = getLanguage(payloadLanguage, this.defaultLanguage, this.options);
    return { id, _language: language };
  }
  getSecuritizedDerivativeData(payload) {
    var _a2;
    const idInstrument = this.getIdInstrument(payload);
    const request = this.getSecuritizedDerivativeGetRequest(idInstrument, payload.language);
    const response = this.getEndpoints().securitizedDerivativeGet.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateSecuritizedDerivativeGet(payload) {
    await this.updateInstrumentGetByNotation(payload);
    const idInstrument = this.getIdInstrument(payload);
    const request = this.getSecuritizedDerivativeGetRequest(idInstrument, payload.language);
    return this.getEndpoints().securitizedDerivativeGet.updateState(request);
  }
  getIdInstrument(payload) {
    const instrumentData = this.getInstrumentGetByNotationData(payload);
    if (!(instrumentData == null ? void 0 : instrumentData.id)) {
      throw new Error("Could not get instrument id");
    }
    return instrumentData.id;
  }
}

export { PortfolioTransactionAddStoreModuleFactory };
